import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FaEnvelope, FaLock, FaUser } from 'react-icons/fa';
import toast from 'react-hot-toast';

const Auth = () => {
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode') === 'register' ? 'register' : 'login';
  const navigate = useNavigate();
  const { login, register, loading } = useAuth();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: ''
  });

  const [error, setError] = useState('');
  const [loadingState, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const { email, password, name } = formData;

      if (mode === 'register') {
        const success = await register(email, password, name);
        if (success) {
          toast.success('Successfully signed up!');
          navigate('/');
        }
      } else {
        const success = await login(email, password);
        if (success) {
          toast.success('Successfully logged in!');
          navigate('/');
        }
      }
    } catch (err) {
      setError(err.message || 'An error occurred');
      toast.error(err.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <div className="min-h-screen bg-nvidia-dark py-20">
      <div className="container mx-auto px-6">
        <div className="max-w-md mx-auto">
          <h1 className="text-4xl font-bold text-center mb-8">
            {mode === 'register' ? 'Create Account' : 'Welcome Back'}
          </h1>

          <div className="bg-nvidia-dark-800 p-8 rounded-lg border border-nvidia-dark-600">
            <form onSubmit={handleSubmit} className="space-y-6">
              {mode === 'register' && (
                <div>
                  <label className="block text-sm font-medium mb-2">Name</label>
                  <div className="relative">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                      <FaUser />
                    </span>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full py-2 pl-10 pr-4 bg-nvidia-dark border border-nvidia-dark-600 rounded-lg focus:outline-none focus:border-nvidia-green"
                      placeholder="Enter your name"
                      required
                    />
                  </div>
                </div>
              )}

              <div>
                <label className="block text-sm font-medium mb-2">Email</label>
                <div className="relative">
                  <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                    <FaEnvelope />
                  </span>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full py-2 pl-10 pr-4 bg-nvidia-dark border border-nvidia-dark-600 rounded-lg focus:outline-none focus:border-nvidia-green"
                    placeholder="Enter your email"
                    required
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Password</label>
                <div className="relative">
                  <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                    <FaLock />
                  </span>
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    className="w-full py-2 pl-10 pr-4 bg-nvidia-dark border border-nvidia-dark-600 rounded-lg focus:outline-none focus:border-nvidia-green"
                    placeholder="Enter your password"
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={loadingState}
                className="w-full py-3 px-4 bg-nvidia-green text-black rounded-lg font-semibold hover:bg-opacity-90 transition-colors disabled:opacity-50"
              >
                {loadingState ? 'Processing...' : mode === 'register' ? 'Create Account' : 'Sign In'}
              </button>
            </form>

            <div className="mt-6 text-center">
              <button
                onClick={() => navigate(`/auth${mode === 'register' ? '' : '?mode=register'}`)}
                className="text-nvidia-green hover:text-nvidia-green/90 transition-colors"
              >
                {mode === 'register'
                  ? 'Already have an account? Sign in'
                  : "Don't have an account? Create one"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth;
